module.exports = __webpack_public_path__ + "img/图片2.b30eb725.png";